import DataTable from "primevue/datatable";
import Column from "primevue/column";
import travellaHeader from "../TravellaHeader";
import SettingsService from "../../shared/settings/settings.service.js";

export default {
    name: "bestseller",
    components: {
        DataTable,
        Column,
        travellaHeader
    },
    props: [],
    data: function() {
        return {
            dane: [],
            tablicaOstatnichMiejsc: [5,6,7,8,9]
        };
    },
    computed: {},
    mounted() {
        this.wczytajDane();
        this.$nextTick(() => {
            travellaHeader.loadHeader();
        });
    },
    methods: {
        wczytajDane() {
            this.$http
                .get(`${SettingsService.bestseller}`)
                .then((response) => {
                    this.dane = response.body;
                });
        }
    }
};
